module.exports = __webpack_public_path__ + "img/mittagsmenueteller.75d9ea2b.jpg";